import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  message: string = "Oops! The page you are looking for does not exist.";
  showRedirectLink = true;
  private readonly checkoutHost = "checkout.paymish.com";
  constructor(
    private localstorageservice: LocalStorageService,
  ) {}
  redirectLink: string = '/auth/login';
  ngOnInit(): void {
    if (window.location.hostname === this.checkoutHost) {
      this.message =
        "Oops! This checkout page does not exist or is missing an access code.";
      this.showRedirectLink = false;
      return;
    }

    if (this.localstorageservice.getLocalStore('token')) {
      this.redirectLink = '/dashboard';
    }
  }
}
